import React from "react";
import { Navigate } from "react-router-dom";
import AccountSupportCenter from "../support/AccountSupportCenter";

function loggedInSupportRedirect() {
  try {
    const token = String(localStorage.getItem("_token") || "");
    if (!token) return null;
    const userData = JSON.parse(localStorage.getItem("user_data") || "null");
    const type = String(userData?.type || "").trim().toLowerCase();
    if (type === "jobseeker") {
      return `${process.env.PUBLIC_URL}/jobseeker/support`;
    }
    if (type === "recruiter") {
      return `${process.env.PUBLIC_URL}/recruiter/support`;
    }
  } catch (_) {
    /* ignore */
  }
  return null;
}

/** Guest-only entry: logged-in jobseekers/recruiters are sent to dashboard support routes. */
const SupportPage = () => {
  const target = loggedInSupportRedirect();
  if (target) {
    return <Navigate to={target} replace />;
  }
  return <AccountSupportCenter variant="public" />;
};

export default SupportPage;
